import React from "react";
import PropTypes from "prop-types";
import { Menu, Dropdown } from "antd";
import { SuccessIcon } from "./components/successIcon";
import AppIcon from "../../assets/svg/appIcon";
import getProductEnabledIcon from "./helpers/getProductEnabledIcon";
import getProductDisabledIcon from "./helpers/getProductDisabledIcon";
import "./app-tool-menu.css";

export const AppToolMenu = ({
  className,
  style,
  appHeaderText,
  toolHeaderText,
  apps,
  tools,
  locale,
  onClickApp,
  onClickTool,
}) => {
  const menu = (
    <Menu>
      <Menu.Item key="apps-title-item" className="app-tool-menu-item">
        <div className="app-tool-menu-item-header">{appHeaderText}</div>
      </Menu.Item>
      {apps.map((app, index) => (
        <Menu.Item
          className="app-tool-menu-item"
          key={`app-item-${index}`}
          disabled={app.enabled && app.status === "Enabled" ? false : true}
          onClick={() => onClickApp(app)}
        >
          <div className="app-tool-menu-item-main-container">
            <div style={{ width: "31px" }}>
              {app.enabled && app.status === "Enabled"
                ? getProductEnabledIcon(app.code)
                : getProductDisabledIcon(app.code)}
            </div>
            <div
              className="app-tool-menu-item-app-title"
              style={{ marginLeft: "14px" }}
            >
              {app.name}
            </div>
            {app.active && <SuccessIcon />}
          </div>

          <div className="app-tool-menu-item-app-description">
            {app.description[locale]}
          </div>
        </Menu.Item>
      ))}
      <Menu.Item key="tools-title-item" className="app-tool-menu-item">
        <div className="app-tool-menu-item-header">{toolHeaderText}</div>
      </Menu.Item>
      {tools.map((tool, index) => (
        <Menu.Item
          className="app-tool-menu-item"
          key={`tool-item-${index}`}
          disabled={tool.enabled && tool.status === "Enabled" ? false : true}
          onClick={() => onClickTool(tool)}
        >
          <div className="app-tool-menu-item-main-container">
            <div style={{ width: "31px" }}>
              {tool.enabled && tool.status === "Enabled"
                ? getProductEnabledIcon(tool.code)
                : getProductDisabledIcon(tool.code)}
            </div>
            <div
              className="app-tool-menu-item-tool-title"
              style={{ marginLeft: "14px" }}
            >
              {tool.name}
            </div>
            {tool.active && <SuccessIcon />}
          </div>

          <div className="app-tool-menu-item-tool-description">
            {tool.description[locale]}
          </div>
        </Menu.Item>
      ))}
    </Menu>
  );
  return (
    <Dropdown
      overlay={menu}
      placement="bottomRight"
      trigger={["click"]}
      overlayClassName={`app-tool-dropdown-menu ${className}`}
      overlayStyle={{ minWidth: "300px", ...style }}
    >
      <div style={{ display: "flex" }}>
        <AppIcon
          style={{ fontSize: "30px", color: "#140335" }}
          className="app-tool-dropdown-icon"
        />
      </div>
    </Dropdown>
  );
};

AppToolMenu.propTypes = {
  appHeaderText: PropTypes.string.isRequired,
  toolHeaderText: PropTypes.string.isRequired,
  apps: PropTypes.shape({
    code: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    description: PropTypes.object.isRequired,
    enabled: PropTypes.bool.isRequired,
    status: PropTypes.string.isRequired,
    active: PropTypes.bool.isRequired,
    path: PropTypes.string.isRequired,
  }).isRequired,
  tools: PropTypes.shape({
    code: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    description: PropTypes.object.isRequired,
    enabled: PropTypes.bool.isRequired,
    status: PropTypes.string.isRequired,
    active: PropTypes.bool.isRequired,
    path: PropTypes.string.isRequired,
  }).isRequired,
  locale: PropTypes.string.isRequired,
  onClickApp: PropTypes.func.isRequired,
  onClickTool: PropTypes.func.isRequired,
  className: PropTypes.string,
  style: PropTypes.object,
};

AppToolMenu.defaultProps = {
  className: undefined,
  style: undefined,
};
